import classnames from 'classnames/bind'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroller'

// Libs
import useLiveMallSearchQuery from '@/hooks/useLiveMallSearchQuery'

// Components
import ProductCard from '@/components/shared/livemallclub/ProductCard'
import MoreButton from '../_shared/MoreButton'
import { StateHandler } from '../_shared/StateHandler'

// Constants
import { ProductSearchType } from '@/types/live-mall-search/types'
import { LIVE_MALL_SEARCH_CATEGORY_MAP } from '../../utils/constants'
import { CategorySharedProps } from '../../utils/types'

// Styles

import styles from './style.module.scss'

const cx = classnames.bind(styles)

type ProductItem = {
  productId: number
  name: string
  discount: number
  price: number
  currency: string
  images: string[]
  minPrice: number
  maxPrice: number
  minOrigPrice: number
  maxOrigPrice: number
}

const ALL_PAGE_DISPLAY_NUMBER = 18

const formatProducts = (products: ProductSearchType[] | undefined): ProductItem[] => {
  if (!products) return []
  return products.map((product) => ({
    productId: product.productId,
    name: product.productName,
    discount: ((product.maxOrigPrice - product.minPrice) / product.maxOrigPrice) * 100,
    price: product.minPrice,
    currency: product.currency,
    images: product.images || [],
    minPrice: product.minPrice,
    maxPrice: product.maxOrigPrice,
    minOrigPrice: product.minOrigPrice,
    maxOrigPrice: product.maxOrigPrice,
  }))
}

const ProductsContent = ({ allQueryResult, ...props }: CategorySharedProps) => {
  const { keyword, category } = useRouter().query
  const isAllCategory = category === 'all' || !category

  const [products, setProducts] = useState<ProductItem[]>([])
  const isEmpty = products.length === 0
  const { data: productQueryResult, isFetching } = useLiveMallSearchQuery({
    keyword: String(keyword),
    type: LIVE_MALL_SEARCH_CATEGORY_MAP.PRODUCTS,
    enabled: !isAllCategory && !!keyword,
  })
  const queryResult = allQueryResult || productQueryResult
  const needShowMore = isAllCategory && formatProducts(queryResult?.productList).length > ALL_PAGE_DISPLAY_NUMBER

  const loadMore = () => {
    // if (products.length >= 27) return
    // setTimeout(() => {
    //   setProducts((prev) => [...prev, ...MOCK_PRODUCTS])
    // }, 1000)
  }

  useEffect(() => {
    if (queryResult) {
      const formattedProducts = formatProducts(queryResult.productList)
      setProducts(isAllCategory ? formattedProducts.slice(0, ALL_PAGE_DISPLAY_NUMBER) : formattedProducts)
    }
  }, [queryResult])

  return (
    <StateHandler isFetching={isFetching} isEmpty={isEmpty}>
      <div className={cx('products-wrapper', { isAllCategory })}>
        <div className={cx('products-content', { isAllCategory })} {...props}>
          <InfiniteScroll pageStart={0} loadMore={loadMore} hasMore={products.length < 27}>
            <div className={cx('products-content__list', { isAllCategory })}>
              {products.map((product) => {
                return (
                  <ProductCard
                    key={product.productId}
                    productName={product.name}
                    minPrice={product.minPrice}
                    maxPrice={product.maxPrice}
                    currency={product.currency}
                    images={product.images}
                    tags={[]}
                    productId={product.productId}
                    merchantId={''}
                    merchantName={''}
                    categoryId={0}
                    categoryName={''}
                    productDesc={''}
                    shippingDays={0}
                    minLivePrice={0}
                    minOrigPrice={product.minOrigPrice}
                    maxOrigPrice={product.maxOrigPrice}
                    livePrice={0}
                    origPrice={0}
                    status={0}
                    saleQuantity={0}
                    productDetail={''}
                    useFrom={''}
                    inlineStyle={{
                      backgroundColor: isAllCategory ? 'white' : '#F6F6F6',
                    }}
                    isSearchPage
                    isMiniWidth
                  />
                )
              })}
            </div>
          </InfiniteScroll>
        </div>
        {needShowMore && <MoreButton category='products' />}
      </div>
    </StateHandler>
  )
}

export default ProductsContent
